import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { bidRatingsBackend } from './bid-ratings.backend';
import { bidRatingsReducer } from './bid-ratings.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('bidRatings', bidRatingsReducer),
    BackendModule.forFeature('bidRatings', bidRatingsBackend),
  ],
})
export class DatastoreBidRatingsModule {}
